// Lookup_CoachingRole
export enum CoachingRole {
    PERFORMER = 1,
    MANAGER,
    OBSERVER,
    COACH,
}
